import {ConfEnv} from "../../../config/config";
import publicRequest from "../../../Infra/http/private.request";

export const getCustomBoardsService = async () => {
  return publicRequest.get(ConfEnv.API_CUSTOM_BOARDS.URL);
};
